// extracted by mini-css-extract-plugin
export default {"terms":"ryMwRktRFXEhgaTX4Mo6","links":"ydBv_cfEuEWLutiPGdtc"};